/** Route paths (WEB-004). Import these instead of writing path strings in components. */
export const paths = {
  home: "/",
  signIn: "/sign-in",
  signUp: "/sign-up",
  resetPassword: "/reset-password",
  /** Router template — use `acceptInvitationPath(token)` to build a real link. */
  acceptInvitation: "/accept-invitation/:token",
  /** org_admin: own org (from the session). super_admin: needs `organizationAdminFor(orgId)`. */
  organizationAdmin: "/admin/organization",
  organizationAdminWithId: "/admin/organization/:orgId",
  patients: "/patients",
  patientDetail: "/patients/:id",
  datasets: "/datasets",
  datasetDetail: "/datasets/:id",
  aiModels: "/admin/ai-models",
  platformAdmin: "/admin/platform",
  secondOpinions: "/second-opinions",
  doctorNetwork: "/doctor-network",
  meetingsTrips: "/meetings-trips",
} as const;

/** ORG-EPIC (B02.04): the link an admin shares after creating an invitation. */
export function acceptInvitationPath(token: string): string {
  return `/accept-invitation/${encodeURIComponent(token)}`;
}

/** ORG-EPIC (B02.06): super_admin's link to a specific organization (they have no home org). */
export function organizationAdminFor(orgId: string): string {
  return `/admin/organization/${encodeURIComponent(orgId)}`;
}

/** PAT-EPIC (B03.02): link to one patient's detail page. */
export function patientDetailPath(id: string): string {
  return `/patients/${encodeURIComponent(id)}`;
}

/** DS-EPIC (B07.02): link to one dataset's detail page. */
export function datasetDetailPath(id: string): string {
  return `/datasets/${encodeURIComponent(id)}`;
}

/** Route metadata read by the root layout (document title) — WCAG 2.4.2. */
export interface RouteHandle {
  readonly title: string;
}

export const APP_NAME = "ThyroAID";

export function documentTitle(pageTitle: string | undefined): string {
  return pageTitle ? `${pageTitle} — ${APP_NAME}` : APP_NAME;
}
